// Einwilligungstexte im Willkommensschritt der Erfassung. Hier zentral,
// damit Erfassung, Bericht und Datenschutzhinweise denselben Wortlaut zeigen.
//
// Wortlaut Trainingsfotos festgelegt am 06.10.2026: bewusst "gespeichert",
// NICHT "anonymisiert". Die Kopien tragen Inventar-Labels und sind damit
// nur ohne direkten Bezug, aber nicht anonym (PROJEKT.md §5).
// 30.10.2026: Das Pflicht-Häkchen ist eine Kenntnisnahme, keine Einwilligung; Grundlage für Kundendaten ist allein
// die Vertragsvorbereitung (Art. 6 Abs. 1 lit. b DSGVO). Einwilligung nur noch für die Trainingsfotos.

export const CONSENT_PRIVACY_LABEL =
  "Mir ist bekannt, dass meine Angaben und Fotos zur Erstellung meines Umzugsangebots verarbeitet und an das " +
  "Umzugsunternehmen übermittelt werden.";

/** Kunden-Version (ohne Firma): Umzugsscan ist verantwortlich, keine Übermittlung an Firmen. */
export const CONSENT_PRIVACY_LABEL_PRIVAT =
  "Mir ist bekannt, dass Umzugsscan meine Angaben und Fotos verarbeitet, um meine Umzugsaufnahme " +
  "zu erstellen. Weitergegeben wird sie nur, wenn ich das selbst tue oder zustimme.";

export const CONSENT_TRAINING_LABEL = "Fotos dürfen zur Verbesserung der Erkennung gespeichert werden.";

export const CONSENT_TRAINING_HINT =
  "Freiwillig. Ohne Zustimmung werden Ihre Fotos nach Ablauf der Frist vollständig gelöscht.";
